<template>
  <div class="organization">
    <!-- <h1>acquirer</h1> -->
    <v-snackbar
      v-model="snackbar"
      :timeout="6000"
      :color="snackbar_color"
      location="top"
      max-height="10cm"
      max-width="5cm"
      multi-line
    >
      {{ snackbar_text }}
    </v-snackbar>

    <v-row no-gutters>
      <v-col cols="auto" class="me-auto">
        <!-- <v-sheet class="ma-2 pa-2">Acquirer</v-sheet> -->
        <v-sheet>
          <v-breadcrumbs
            :items="[{ text: $t('aids'), disabled: true, href: '/' }]"
          ></v-breadcrumbs>
        </v-sheet>
      </v-col>
      <v-col cols="1" class="mr-7">
        <v-sheet>
          <!-- <v-btn prepend-icon="mdi-plus" color="primary" @click="compose" v-if="this.global_permissions.includes('CONFIG_CARD_CREATE')">              
              <template v-slot:prepend >
                <v-icon color="white"></v-icon>
              </template>
              Add AID
            </v-btn> -->
          <v-btn
            class="button_size mr-10"
            color="blue"
            prepend-icon="mdi-plus"
            @click="compose"
            v-if="
              this.global_permissions.includes('ROLE_MOD_CARD')              
            "
          >
            <template v-slot:prepend>
              <v-icon color="white"></v-icon>
            </template>
            {{ $t("add_aids") }}
          </v-btn>
        </v-sheet>
      </v-col>
    </v-row>

    <v-row class="search_row pl-1">
      <v-col cols="3" class="ml-3">
        <v-text-field
          append-inner-icon="mdi-close-circle"
          append-icon="mdi-magnify"
          density="compact"
          :label="$t('search')"
          variant="solo"
          hide-details
          single-line
          dense
          v-model="query"
          @click:append-inner="resetData"
          @click:append="searchAid"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- Loading Spinner -->
    <v-progress-circular
      v-if="loading"
      indeterminate
      color="blue"
      size="25"
      class="loading-spinner"
    ></v-progress-circular>

    <v-container v-else class="pr-10">
      <v-row no-gutters>
        <v-col>
          <v-sheet>
            <v-card>
              <!-- <v-card-title>
          
          <v-spacer></v-spacer>
          <v-row>
            <v-col cols="4">                                 
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>                                              
            </v-col>
            <v-col cols="4">                              
              
            </v-col>
          </v-row>          
        </v-card-title>
 -->
              <v-data-table
                :headers="headers"
                :items="aids"
                class="elevation-1 custom-table-style"
                :search="search"
                :items-per-page="itemsPerPage"
                :items-length="totalItems"
                disable-pagination
                :hide-default-footer="true"
                :fixed-header="true"
                :loading="loading"
              >
                <!-- FOR EXPANSION -->
                <template v-slot:expanded-row="{ columns, item }">
                  <!-- <tr>
            <td :colspan="columns.length">               
              More info about {{ item.value.deviceId }}
            </td>
          </tr> -->
                  <tr>
                    <td>{{ $t("acquirer") }}</td>
                    <td :colspan="columns.length" style="padding: 10px;">
                      <tr v-for="it in item.raw.acquirers" :key="it.id">
                        <td>{{ it.acquirerName }}</td>
                      </tr>
                    </td>
                  </tr>
                </template>

                <template v-slot:item.onlinePin="{ item }">
                  <td>{{ item.raw.onlinePin }}</td>
                </template>

                <template v-slot:item.randTransSel="{ item }">
                  <td>{{ item.raw.randTransSel }}</td>
                </template>

                <template v-slot:item.velocityCheck="{ item }">
                  <td>{{ item.raw.velocityCheck }}</td>
                </template>

                <!-- <template v-slot:item.acquirers="{ item }">
                  <td>
                    <tr v-for="it in item.raw.acquirers" :key="it.id">
                      <td>{{ it.acquirerName }}</td>
                    </tr>
                  </td>
                </template> -->

                <template v-slot:item.actions="{ item }">
                  <!-- <v-icon color="green" small class="mr-2" @click="compose_update(item.value.aidId)" v-if="this.global_permissions.includes('CONFIG_CARD_EDIT')">mdi-pencil</v-icon>
              <v-icon color="red" small @click="compose_delete(item.value.aidId)" v-if="this.global_permissions.includes('CONFIG_CARD_DELETE')">mdi-delete</v-icon> -->
                  <v-tooltip :text="$t('Update')" location="top">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        v-bind="props"
                        color="green"
                        small
                        class="mr-2"
                        @click="compose_update(item.raw.id)"
                        v-if="
                          this.global_permissions.includes('ROLE_MOD_CARD')                          
                        "
                        >mdi-pencil-circle</v-icon
                      >
                    </template>
                  </v-tooltip>
                  <v-tooltip :text="$t('Delete')" location="top">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        v-bind="props"
                        color="red"
                        small
                        @click="compose_delete(item.raw.id)"
                        v-if="
                          this.global_permissions.includes('ROLE_DEL_CARD') ||
                          this.global_permissions.includes('ROLE_STAFF_ADMIN')
                        "
                        >mdi-delete-circle</v-icon
                      >
                    </template>
                  </v-tooltip>
                </template>

                <template v-slot:bottom>
                  <div class="text-center pt-2">
                    <v-pagination
                      v-model="page"
                      :length="pageCount"
                      total-visible="7"
                      @update:model-value="page"
                    ></v-pagination>
                  </div>
                </template>
              </v-data-table>
            </v-card>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>

    <!-- ADD DIALOG -->
    <v-dialog v-model="dialog" persistent width="800" max-height="800">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title class="d-flex justify-space-between ma-3">
              <span class="text-h5">{{ $t("add_aids") }}</span>
              <v-icon @click="dialog = false"
                >mdi mdi-close-circle-outline</v-icon
              >
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="6">
                    <v-text-field
                      label="Aid Name*"
                      :readonly="loading"
                      :rules="[required, validateName]"
                      clearable
                      v-model="aid_data.f_aidName"
                    ></v-text-field>
                  </v-col>
                  <!-- <v-col cols="6">                                 
                        <v-text-field label="aid" :readonly="loading" :rules="[required, aid_check]" clearable v-model="aid_data.f_aid" ></v-text-field>                                              
                      </v-col> -->
                  <v-col cols="6">
                    <v-text-field
                      label="aid"
                      :readonly="loading"
                      :rules="[required, validateAID]"
                      @change="checkAid(aid_data.f_aid)"
                      clearable
                      v-model="aid_data.f_aid"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="selFlag"
                      :readonly="loading"
                      :rules="[required, validateLimit1]"
                      clearable
                      v-model="aid_data.f_selFlag"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="priority*"
                      :readonly="loading"
                      :rules="[required, validateLimit1]"
                      clearable
                      v-model="aid_data.f_priority"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-select
                      :items="['true', 'false']"
                      label="Select onlinePin"
                      :rules="[required]"
                      v-model="aid_data.f_onlinePin"
                    ></v-select>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="targetPer"
                      :readonly="loading"
                      :rules="[required, validateLimit2]"
                      clearable
                      v-model="aid_data.f_targetPer"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="maxTargetPer"
                      :readonly="loading"
                      :rules="[required, validateLimit2]"
                      clearable
                      v-model="aid_data.f_maxTargetPer"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="floorLimit"
                      :rules="[required, validateLimit3]"
                      :readonly="loading"
                      clearable
                      v-model="aid_data.f_floorLimit"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="floorLimitCheckFlg"
                      :readonly="loading"
                      :rules="[required, validateLimit1]"
                      clearable
                      v-model="aid_data.f_floorLimitCheckFlg"
                    ></v-text-field>
                  </v-col>
                  <!-- <v-col cols="4">                                 
                        <v-text-field label="rdClssTxnLmt" :readonly="loading" :rules="[required]" clearable v-model="aid_data.f_rdClssTxnLmt" ></v-text-field>                                              
                      </v-col>
                      <v-col cols="4">                                 
                        <v-text-field label="rdClssFLmt" :readonly="loading" :rules="[required]" clearable v-model="aid_data.f_rdClssFLmt" ></v-text-field>                                              
                      </v-col>
                      <v-col cols="4">                                 
                        <v-text-field label="rdClssFLmtFlg" :readonly="loading" :rules="[required]" clearable v-model="aid_data.f_rdClssFLmtFlg" ></v-text-field>                                              
                      </v-col>
                      <v-col cols="4">                                 
                        <v-text-field label="rdCVMLmt" :readonly="loading" :rules="[required]" clearable v-model="aid_data.f_rdCVMLmt" ></v-text-field>                                              
                      </v-col>
                      <v-col cols="4">                                 
                        <v-text-field label="rdCVMLmtFlg" :readonly="loading" :rules="[required]" clearable v-model="aid_data.f_rdCVMLmtFlg" ></v-text-field>                                              
                      </v-col> -->
                  <v-col cols="4">
                    <v-select
                      :items="['true', 'false']"
                      label="Select randTransSel"
                      :rules="[required]"
                      v-model="aid_data.f_randTransSel"
                    ></v-select>
                  </v-col>
                  <v-col cols="4">
                    <v-select
                      :items="['true', 'false']"
                      label="Select velocityCheck"
                      :rules="[required]"
                      v-model="aid_data.f_velocityCheck"
                    ></v-select>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="threshold"
                      :readonly="loading"
                      clearable
                      :rules="[required, validateLimit1]"
                      v-model="aid_data.f_threshold"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="tacDenial"
                      :readonly="loading"
                      :rules="[required, validateText3]"
                      clearable
                      v-model="aid_data.f_tacDenial"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="tacOnline"
                      :readonly="loading"
                      :rules="[required, validateText3]"
                      clearable
                      v-model="aid_data.f_tacOnline"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="tacDefault"
                      :readonly="loading"
                      :rules="[required, validateText3]"
                      clearable
                      v-model="aid_data.f_tacDefault"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="acquirerId"
                      :readonly="loading"
                      clearable
                      v-model="aid_data.f_acquirerId"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="dDOL"
                      :readonly="loading"
                      :rules="[validateNN]"
                      clearable
                      v-model="aid_data.f_dDOL"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="tDOL"
                      :readonly="loading"
                      :rules="[validateNN]"
                      clearable
                      v-model="aid_data.f_tDOL"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="riskManageData"
                      :readonly="loading"
                      clearable
                      v-model="aid_data.f_riskManageData"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="version"
                      :rules="[required]"
                      v-model="aid_data.f_version"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="Terminal Type"
                      :rules="[required, validateText]"
                      v-model="aid_data.f_terminalType"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="Terminal Capability"
                      :rules="[required, validateText2]"
                      v-model="aid_data.f_terminalCapa"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="Aditional Terminal Capability"
                      :rules="[required, validateText3]"
                      v-model="aid_data.f_addTerminalCap"
                    ></v-text-field>
                  </v-col>
                  <!-- <v-col cols="4">                                 
                        <v-select
                          :items="organization"
                          item-title="orgName"
                          item-value="orgId"                          
                          label="Select Organization*"                          
                          :rules="[required]"
                          v-model="aid_data.f_orgId"
                        ></v-select>                      
                      </v-col> -->
                  <v-col cols="12">
                    <!-- <v-autocomplete
                      :items="acquirers"
                      item-title="name"
                      item-value="id"
                      label="Select Acquirers"
                      multiple
                      :rules="[required]"
                      v-model="aid_data.f_acquirerList"
                    ></v-autocomplete> -->

                    <v-select
                      v-model="aid_data.f_acquirerList"
                      :items="acquirers"
                      item-title="name"
                      item-value="id"
                      label="Select Acquirers"
                      multiple
                    >
                      <template v-slot:prepend-item>
                        <v-list-item title="Select All" @click="toggle">
                          <template v-slot:prepend>
                            <v-checkbox-btn
                              :color="likesSome ? 'indigo-darken-4' : undefined"
                              :indeterminate="likesSome && !likesAll"
                              :model-value="likesAll"
                            ></v-checkbox-btn>
                          </template>
                        </v-list-item>

                        <v-divider class="mt-2"></v-divider>
                      </template>
                    </v-select>
                  </v-col>
                </v-row>
              </v-container>
              <small>*{{ $t("indicateRequires") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog = false">{{
                $t("Close")
              }}</v-btn>
              <!-- <v-btn :disabled="!form" :loading="loading" color="success" type="submit" variant="text"  @click="addAid" >Save</v-btn> TO BE RESTORED-->
              <v-btn
                :loading="loading"
                color="success"
                type="submit"
                variant="text"
                @click="addAid"
              >
                {{ $t("Save") }}</v-btn
              >
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END ADD DIALOG -->

    <!-- UPDATE  DIALOG -->
    <v-dialog v-model="dialog_update" persistent width="800">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title class="d-flex justify-space-between ma-3">
              <span class="text-h5"> {{ $t("update_aids") }}</span>
              <v-icon @click="dialog_update = false"
                >mdi mdi-close-circle-outline</v-icon
              >
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="6">
                    <v-text-field
                      label="Aid Name*"
                      :readonly="loading"
                      :rules="[required, validateName]"
                      clearable
                      v-model="aid_data.f_aidName"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <!-- <v-text-field label="aid" :readonly="loading" :rules="[required]" clearable @change="checkAid(aid_data.f_aid)" v-model="aid_data.f_aid" ></v-text-field>  -->
                    <v-text-field
                      label="aid"
                      :readonly="loading"
                      :rules="[required, validateAID]"
                      @change="checkAid(aid_data.f_aid)"
                      clearable
                      v-model="aid_data.f_aid"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="selFlag"
                      :rules="[required, validateLimit1]"
                      clearable
                      v-model="aid_data.f_selFlag"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="priority*"
                      :readonly="loading"
                      :rules="[required, validateLimit1]"
                      clearable
                      v-model="aid_data.f_priority"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-select
                      :items="['true', 'false']"
                      label="Select onlinePin"
                      v-model="aid_data.f_onlinePin"
                    ></v-select>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="targetPer"
                      :readonly="loading"
                      :rules="[required, validateLimit2]"
                      clearable
                      v-model="aid_data.f_targetPer"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="maxTargetPer"
                      :readonly="loading"
                      :rules="[required, validateLimit2]"
                      clearable
                      v-model="aid_data.f_maxTargetPer"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="floorLimit"
                      :rules="[required, validateLimit3]"
                      :readonly="loading"
                      clearable
                      v-model="aid_data.f_floorLimit"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="floorLimitCheckFlg"
                      :readonly="loading"
                      :rules="[required, validateLimit1]"
                      clearable
                      v-model="aid_data.f_floorLimitCheckFlg"
                    ></v-text-field>
                  </v-col>
                  <!-- <v-col cols="4">                                 
                        <v-text-field label="rdClssTxnLmt" :readonly="loading" clearable v-model="aid_data.f_rdClssTxnLmt" ></v-text-field>                                              
                      </v-col>
                      <v-col cols="4">                                 
                        <v-text-field label="rdClssFLmt" :readonly="loading" clearable v-model="aid_data.f_rdClssFLmt" ></v-text-field>                                              
                      </v-col>
                      <v-col cols="4">                                 
                        <v-text-field label="rdClssFLmtFlg" :readonly="loading" clearable v-model="aid_data.f_rdClssFLmtFlg" ></v-text-field>                                              
                      </v-col>
                      <v-col cols="4">                                 
                        <v-text-field label="rdCVMLmt" :readonly="loading" clearable v-model="aid_data.f_rdCVMLmt" ></v-text-field>                                              
                      </v-col>
                      <v-col cols="4">                                 
                        <v-text-field label="rdCVMLmtFlg" :readonly="loading" clearable v-model="aid_data.f_rdCVMLmtFlg" ></v-text-field>                                              
                      </v-col> -->
                  <v-col cols="4">
                    <v-select
                      :items="['true', 'false']"
                      label="Select randTransSel"
                      v-model="aid_data.f_randTransSel"
                    ></v-select>
                  </v-col>
                  <v-col cols="4">
                    <v-select
                      :items="['true', 'false']"
                      label="Select velocityCheck"
                      :rules="[required]"
                      v-model="aid_data.f_velocityCheck"
                    ></v-select>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="threshold"
                      :readonly="loading"
                      clearable
                      :rules="[required, validateLimit1]"
                      v-model="aid_data.f_threshold"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="tacDenial"
                      :readonly="loading"
                      :rules="[required, validateText3]"
                      clearable
                      v-model="aid_data.f_tacDenial"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="tacOnline"
                      :readonly="loading"
                      :rules="[required, validateText3]"
                      clearable
                      v-model="aid_data.f_tacOnline"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="tacDefault"
                      :readonly="loading"
                      :rules="[required, validateText3]"
                      clearable
                      v-model="aid_data.f_tacDefault"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="acquirerId"
                      :readonly="loading"
                      clearable
                      v-model="aid_data.f_acquirerId"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="dDOL"
                      :readonly="loading"
                      :rules="[validateNN]"
                      clearable
                      v-model="aid_data.f_dDOL"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="tDOL"
                      :readonly="loading"
                      :rules="[validateNN]"
                      clearable
                      v-model="aid_data.f_tDOL"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="riskManageData"
                      :readonly="loading"
                      clearable
                      v-model="aid_data.f_riskManageData"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="version"
                      :rules="[required]"
                      v-model="aid_data.f_version"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="Terminal Type"
                      :rules="[required, validateText]"
                      v-model="aid_data.f_terminalType"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="Terminal Capability"
                      :rules="[required, validateText2]"
                      v-model="aid_data.f_terminalCapa"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="Aditional Terminal Capability"
                      :rules="[required, validateText3]"
                      v-model="aid_data.f_addTerminalCap"
                    ></v-text-field>
                  </v-col>
                  <!-- <v-col cols="4">                                 
                        <v-select
                          :items="organization"
                          item-title="orgName"
                          item-value="orgId"                          
                          label="Select Organization*"                          
                          v-model="aid_data.f_orgId"
                          :rules="[required]"
                        ></v-select>                      
                      </v-col> -->
                  <v-col cols="12">
                    <!-- <v-autocomplete
                      :items="acquirers"
                      item-title="name"
                      item-value="id"
                      label="Select Acquirers"
                      multiple
                      :rules="[required]"
                      v-model="aid_data.f_acquirerList"
                    ></v-autocomplete> -->

                    <v-select
                      v-model="aid_data.f_acquirerList"
                      :items="acquirers"
                      item-title="name"
                      item-value="id"
                      label="Select Acquirers"
                      multiple
                    >
                      <template v-slot:prepend-item>
                        <v-list-item title="Select All" @click="toggle">
                          <template v-slot:prepend>
                            <v-checkbox-btn
                              :color="likesSome ? 'indigo-darken-4' : undefined"
                              :indeterminate="likesSome && !likesAll"
                              :model-value="likesAll"
                            ></v-checkbox-btn>
                          </template>
                        </v-list-item>

                        <v-divider class="mt-2"></v-divider>
                      </template>
                    </v-select>

                  </v-col>
                </v-row>
              </v-container>
              <small>*{{ $t("indicateRequires") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog_update = false">{{
                $t("Close")
              }}</v-btn>
              <v-btn
                :loading="loading"
                color="success"
                type="submit"
                variant="text"
                @click="updateAid"
                >{{ $t("Update") }}</v-btn
              >
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END UPDATE  DIALOG -->

    <!-- DELETE  DIALOG -->
    <!-- <v-dialog
              v-model="dialog_delete"
              persistent
              width="500"
            >              
              <v-card>
                <v-card-title>
                  <div class="container">
                  <span class="text-h5">Do you want to delete?</span></div>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                                           
                    </v-row>
                  </v-container>
                  
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue-darken-1" variant="text" @click="dialog_delete = false">Close</v-btn>                 
                  <v-btn color="blue-darken-1" variant="text" @click="deleteAid">Delete</v-btn>                  
                </v-card-actions>
              </v-card>
            </v-dialog> -->

    <v-dialog v-model="dialog_delete" persistent width="400">
      <v-card>
        <template v-slot:title>
          <span class="font-weight-medium-black">{{ $t("deleteFile") }}</span>
        </template>

        <v-card-text class="bg-surface-light py-4">
          {{ $t("deleteText") }}
        </v-card-text>
        <v-card-actions class="mb-2 mr-2">
          <v-spacer></v-spacer>
          <v-btn color="red" variant="flat" @click="deleteAid">{{
            $t("Delete")
          }}</v-btn>
          <v-btn variant="flat" @click="dialog_delete = false">{{
            $t("Close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- END UPDATE DIALOG -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Aid",
  props: {
    msg: String,
  },
  data() {
    return {
      name: "",
      emits: ["reload"],
      acquirers: [],
      aids: [],
      organization: [],

      dialog: false,
      dialog_update: false,
      dialog_delete: false,

      // aid_data:{  //used
      //   f_aidName: '',
      //   f_aid: '',
      //   f_selFlag: 0,
      //   f_priority: 0,
      //   f_onlinePin: true,
      //   f_targetPer: 0,
      //   f_maxTargetPer: 0,
      //   f_floorLimit: 0,
      //   f_floorLimitCheckFlg: 1,
      //   f_rdClssTxnLmt: 999999999900,
      //   f_rdClssFLmt: 1,
      //   f_rdClssFLmtFlg: 0,
      //   f_rdCVMLmt: 100000,
      //   f_rdCVMLmtFlg: 1,
      //   f_randTransSel: true,
      //   f_velocityCheck: true,
      //   f_threshold: 0,
      //   f_tacDenial: '0010000000',
      //   f_tacOnline: 'D84004F800',
      //   f_tacDefault: 'D84000A800',
      //   f_acquirerId: '000000123456',
      //   f_dDOL: '039F3704',
      //   f_tDOL: '0F9F02065F2A029A039C0195059F3704',
      //   f_version: '008C',
      //   f_riskManageData: '',
      //   f_orgId: ''

      // },

      aid_data: {
        //used
        f_aidName: "",
        f_aid: "",
        f_selFlag: 1,
        f_priority: 1,
        f_onlinePin: true,
        f_targetPer: 1,
        f_maxTargetPer: 1,
        f_floorLimit: 0,
        f_floorLimitCheckFlg: 1,
        f_rdClssTxnLmt: 999999999900,
        f_rdClssFLmt: 10,
        f_rdClssFLmtFlg: 1,
        f_rdCVMLmt: 100000,
        f_rdCVMLmtFlg: 1,
        f_randTransSel: true,
        f_velocityCheck: true,
        f_threshold: 0,
        f_tacDenial: "0010000000",
        f_tacOnline: "D84004F800",
        f_tacDefault: "D84000A800",
        f_acquirerId: "000000123456",
        f_dDOL: "039F3704",
        f_tDOL: "0F9F02065F2A029A039C0195059F3704",
        f_version: "008C",
        f_terminalType: "22",
        f_terminalCapa: "E0F8C8",
        f_addTerminalCap: "FF80F0A001",
        f_riskManageData: "",
        f_acquirerList: [],
        f_orgId: "",
      },

      aidId: "",
      search: "",
      headers: [
        {
          title: "AID Name",
          align: "start",
          sortable: false,
          key: "aidName",
          width: "200px"
        },
        { title: "", key: "data-table-expand" },
        { title: "AID", key: "aid" },
        // { title: "selFlag", key: "selFlag" },
        // { title: "priority", key: "priority" },
        // { title: "onlinePin", key: "onlinePin" }, //true or false
        // { title: "targetPer", key: "targetPer" },
        // { title: "maxTargetPer", key: "maxTargetPer" },
        { title: "floorLimit", key: "floorLimit" },
        // { title: "floorLimitCheckFlg", key: "floorLimitCheckFlg" },
        // { title: "randTransSel", key: "randTransSel" }, //true of false
        // { title: "velocityCheck", key: "velocityCheck" }, //true or false
        // { title: "threshold", key: "threshold" },
        { title: "tacDenial", key: "tacDenial" },
        { title: "tacOnline", key: "tacOnline" },
        { title: "tacDefault", key: "tacDefault" },
        // { title: "acquirerId", key: "acquirerId" },
        // { title: "dDOL", key: "dDOL" },
        // { title: "tDOL", key: "tDOL" },
        { title: "version", key: "version" },
        { title: "Terminal Type", key: "terminalType" },
        { title: "Terminal Capability", key: "terminalCapability" },
        {
          title: "Addition Term Capability",
          key: "terminalAdditionalCapability",
        },
        // { title: "riskManageData", key: "riskManageData" },
        // { title: "Acquirers", key: "acquirers", sortable: true },
        { title: "Organization", key: "organization.orgName" },
        { title: "Actions", key: "actions", sortable: false, width: "100px" },
      ],

      //form
      form: false,
      loading: true,
      exist: false,

      //snackbar
      snackbar: false,
      snackbar_text: "",
      snackbar_color: "",

      existing_aid: "",

      //pagination
      page: 1,
      itemsPerPage: 5,
      totalItems: 0,
      totalPages: 0,
      query: "",
    };
  },

  created() {},

  computed: {
    pageCount() {
      // console.log("ssss", this.totalItems + " / " + this.itemsPerPage);
      let count = Math.ceil(this.totalItems / this.itemsPerPage);

      return count;
    },

    //for select all acquirers
    likesAll () {  
        //return this.selectedFruits.length === this.fruits.length
        return this.aid_data.f_acquirerList.length === this.acquirers.length
    },
    likesSome () {
        //return this.selectedFruits.length > 0
        return this.aid_data.f_acquirerList.length > 0
    },
  },

  watch: {
    page(newPage) {
      this.page = newPage;
      this.fetchData();
      // console.log("new page", this.page);
    },
  },

  methods: {
    onSubmit() {
      if (!this.form) return;
    },

    resetInput() {
      this.aid_data.f_aidName = "";
      this.aid_data.f_aid = "";
      this.aid_data.f_selFlag = 1;
      this.aid_data.f_priority = 1;
      this.aid_data.f_onlinePin = true;
      this.aid_data.f_targetPer = 1;
      this.aid_data.f_maxTargetPer = 1;
      this.aid_data.f_floorLimit = 0;
      this.aid_data.f_floorLimitCheckFlg = 1;
      this.aid_data.f_rdClssTxnLmt = 999999999900;
      this.aid_data.f_rdClssFLmt = 10;
      this.aid_data.f_rdClssFLmtFlg = 1;
      this.aid_data.f_rdCVMLmt = 100000;
      this.aid_data.f_rdCVMLmtFlg = 1;
      this.aid_data.f_randTransSel = true;
      this.aid_data.f_velocityCheck = true;
      this.aid_data.f_threshold = 0;
      this.aid_data.f_tacDenial = "0010000000";
      this.aid_data.f_tacOnline = "D84004F800";
      this.aid_data.f_tacDefault = "D84000A800";
      this.aid_data.f_acquirerId = "000000123456";
      this.aid_data.f_dDOL = "039F3704";
      this.aid_data.f_tDOL = "0F9F02065F2A029A039C0195059F3704";
      this.aid_data.f_version = "008C";
      this.aid_data.f_terminalType = "22";
      this.aid_data.f_terminalCapa = "E0F8C8";
      this.aid_data.f_addTerminalCap = "FF80F0A001";
      this.aid_data.f_riskManageData = "";
      this.aid_data.f_acquirerList = [];
      this.aid_data.f_orgId = "";
    },

    resetData() {
      this.query = "";
      this.fetchData();
    },

    //for select all acquirers
    toggle () {
        if (this.likesAll) {
          this.aid_data.f_acquirerList = []
        } else {
          //this.aid_data.f_acquirerList = this.acquirers.slice()
          let i = 0;
          this.aid_data.f_acquirerList = [];
          for (i = 0; i < this.acquirers.length; i++) {
              this.aid_data.f_acquirerList.push(
                this.acquirers[i].id
              );
          }
        }
    },

    /* aid_check(v) {                
          this.checkAid(v)          
          if(this.exist) return true
          return 'AID exist'

          //if(this.exist) return 'AID exist'
          //if(!this.exist) return
      }, */

    show_toast(status, color, text) {
      this.snackbar = status;
      this.snackbar_color = color;
      this.snackbar_text = text;
    },

    compose() {
      this.dialog = true;
      this.resetInput();
      this.checkTokenExpiry();
      this.requests_handler();
    },

    compose_update(id) {
      this.aidId = id;
      this.dialog_update = true;
      this.checkTokenExpiry();
      // console.log("id", id);
      this.requests_handler2();
    },

    compose_delete(id) {
      this.aidId = id;
      this.dialog_delete = true;
    },

    requests_handler() {
      axios
        .all([
          //axios.get(window.baseurl+""+"org/get/"+this.orgId , {"headers": {'Authorization': 'Bearer ' + this.$cookies.get('accessToken')} }),
          axios.get(window.baseurl + "acquirers/org/" + this.orgId, {
            params: { pagesize: 100 },
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
        ])
        .then(
          axios.spread((acquirer_response) => {
            // console.log("data1", acquirer_response.data);
            //if response data is an object // handle it as below
            /* if(org_response.status == 200){ 
                
                  this.organization = [];  //remove all items from array
                  this.organization.push(org_response.data);                          
                  console.log("organization", this.organization)                
                  

              } */

            //if response data is an array // handle it as below
            if (acquirer_response.status == 200) {
              if (
                acquirer_response.data.records != null &&
                acquirer_response.data.records.length > 0
              ) {
                let i = 0;
                this.acquirers = []; //remove all items from array
                for (i = 0; i < acquirer_response.data.records.length; i++) {
                  this.acquirers.push({
                    id: acquirer_response.data.records[i].id,
                    name: acquirer_response.data.records[i].acquirerName,
                  });
                  //console.log("acquirers", this.acquirers)
                }
              }
            }
          })
        );
    }, //end of requests_handler method

    async addAid() {
      //this.dialog = false
      // console.log("form data", this.aid_data);
      this.checkTokenExpiry();
      //DO NOT DELETE
      /* this.exist = false;

          try {
                let result_aid = await axios.get(window.baseurl+"aids/"+ this.aid_data.f_aid + "/"+ this.orgId , 
                  {"headers": {'Authorization': 'Bearer ' + this.accessToken} }
                )
                console.log("RESPONSE", result_aid)
                if (result_aid.status == 200) {
                  //alert("device exist");
                  //this.show_toast(true, "warning", "Aid exist"); 
                  this.$root.vtoast.showError({message: this.aid_data.f_aid + " Already exist"})
                  console.log("EXIST", "AID exist")
                  this.exist = true;
                  //console.log("EXIST value 1", this.exist)
                  
                }   
          }
          catch (error) {
                console.log("EXIST", "aid does not exist")
                console.log(error.response.data);
                if(error.response.data.status == 500){
                  this.exist = false;
                  console.log("EXIST value 2", this.exist)
                  
                }
                //this.$root.vtoast.showError({message: error.message})
                
          } */

      if (!this.exist) {
        try {
          let result = await axios.post(
            window.baseurl + "aids",
            {
              aidName: this.aid_data.f_aidName,
              aid: this.aid_data.f_aid,
              selFlag: this.aid_data.f_selFlag,
              priority: this.aid_data.f_priority,
              onlinePin: this.aid_data.f_onlinePin,
              targetPer: this.aid_data.f_targetPer,
              maxTargetPer: this.aid_data.f_maxTargetPer,
              floorLimit: this.aid_data.f_floorLimit,
              floorLimitCheckFlg: this.aid_data.f_floorLimitCheckFlg,
              /* rdClssTxnLmt:this.aid_data.f_rdClssTxnLmt,
                rdClssFLmt:this.aid_data.f_rdClssFLmt,
                rdClssFLmtFlg:this.aid_data.f_rdClssFLmtFlg,
                rdCVMLmt:this.aid_data.f_rdCVMLmt,
                rdCVMLmtFlg:this.aid_data.f_rdCVMLmtFlg, */
              randTransSel: this.aid_data.f_randTransSel,
              velocityCheck: this.aid_data.f_velocityCheck,
              threshold: this.aid_data.f_threshold,
              tacDenial: this.aid_data.f_tacDenial,
              tacOnline: this.aid_data.f_tacOnline,
              tacDefault: this.aid_data.f_tacDefault,
              acquirerId: this.aid_data.f_acquirerId,
              dDOL: this.aid_data.f_dDOL,
              tDOL: this.aid_data.f_tDOL,
              version: this.aid_data.f_version,
              terminalType: this.aid_data.f_terminalType,
              terminalCapability: this.aid_data.f_terminalCapa,
              terminalAdditionalCapability: this.aid_data.f_addTerminalCap,
              riskManageData: this.aid_data.f_riskManageData,
              acquirersList: this.aid_data.f_acquirerList,
              //orgId:this.aid_data.f_orgId,
              organization_id: this.orgId,
              createdBy: this.userEmail,
              updatedBy: this.userEmail,
            },
            { headers: { Authorization: "Bearer " + this.accessToken } }
          );

          if (result.status == 201) {
            //alert("successfull");
            //this.show_toast(true, "success", "Successful");
            // this.$root.vtoast.show({message: result.data.message})
            this.$root.vtoast.show({ message: this.$t("aid_created") });
            window.setInterval(() => {
              this.dialog = false;
              this.$emit("reload");
            }, this.waiting_time);
          }
        } catch (error) {
          //this.show_toast(true, "warning", error.message);
          if (error.response.status == 417) {
            this.$root.vtoast.showError({
              message: error.response.data.message,
            });
          } else if (error.response.status == 500) {
            this.$root.vtoast.showError({
              message: error.response.data.detail,
            });
          } else {
            this.$root.vtoast.showError({
              message: error.response.data.message,
            });
          }
        }
      }
    },

    requests_handler2() {
      axios
        .all([
          axios.get(window.baseurl + "" + "aids/" + this.aidId, {
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
          //axios.get(window.baseurl+""+"org/get/"+this.orgId , {"headers": {'Authorization': 'Bearer ' + this.$cookies.get('accessToken')} }),
          axios.get(window.baseurl + "acquirers/org/" + this.orgId, {
            params: { pagesize: 100 },
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
        ])
        .then(
          axios.spread((aid_response, acquirer_response) => {
            //console.log("data1", aid_response.data);

            //get data for selected id and display data in for dialog
            if (aid_response.status == 200) {
              //this.acquirer_response = acquirer_response.data,
              //console.log("aid Data", this.aid_response);

              this.aid_data.f_aidName = aid_response.data.aidName;
              this.aid_data.f_aid = aid_response.data.aid;
              this.aid_data.f_selFlag = aid_response.data.selFlag;
              this.aid_data.f_priority = aid_response.data.priority;
              this.aid_data.f_onlinePin = aid_response.data.onlinePin;
              this.aid_data.f_targetPer = aid_response.data.targetPer;
              this.aid_data.f_maxTargetPer = aid_response.data.maxTargetPer;
              this.aid_data.f_floorLimit = aid_response.data.floorLimit;
              this.aid_data.f_floorLimitCheckFlg =
                aid_response.data.floorLimitCheckFlg;
              /* this.aid_data.f_rdClssTxnLmt = aid_response.data.rdClssTxnLmt
                this.aid_data.f_rdClssFLmt = aid_response.data.rdClssFLmt
                this.aid_data.f_rdClssFLmtFlg = aid_response.data.rdClssFLmtFlg
                this.aid_data.f_rdCVMLmt = aid_response.data.rdCVMLmt
                this.aid_data.f_rdCVMLmtFlg = aid_response.data.rdCVMLmtFlg */
              this.aid_data.f_randTransSel = aid_response.data.randTransSel;
              this.aid_data.f_velocityCheck = aid_response.data.velocityCheck;
              this.aid_data.f_threshold = aid_response.data.threshold;
              this.aid_data.f_tacDenial = aid_response.data.tacDenial;
              this.aid_data.f_tacOnline = aid_response.data.tacOnline;
              this.aid_data.f_tacDefault = aid_response.data.tacDefault;
              this.aid_data.f_acquirerId = aid_response.data.acquirerId;
              this.aid_data.f_dDOL = aid_response.data.dDOL;
              this.aid_data.f_tDOL = aid_response.data.tDOL;
              this.aid_data.f_version = aid_response.data.version;
              this.aid_data.f_terminalType = aid_response.data.terminalType;
              this.aid_data.f_terminalCapa =
                aid_response.data.terminalCapability;
              this.aid_data.f_addTerminalCap =
                aid_response.data.terminalAdditionalCapability;
              this.aid_data.f_riskManageData = aid_response.data.riskManageData;
              this.aid_data.f_orgId = aid_response.data.orgId;

              this.existing_aid = aid_response.data.aid;

              let i = 0;
              this.aid_data.f_acquirerList = [];
              for (i = 0; i < aid_response.data.acquirers.length; i++) {
                this.aid_data.f_acquirerList.push(
                  aid_response.data.acquirers[i].id
                );
              }
            }

            //if response data is an object // handle it as below
            /* if(org_response.status == 200){               
                this.organization = [];  //remove all items from array
                this.organization.push(org_response.data);                          
                console.log("organization", this.organization)                
              
              } */

            if (acquirer_response.status == 200) {
              if (
                acquirer_response.data.records != null &&
                acquirer_response.data.records.length > 0
              ) {
                let i = 0;
                this.acquirers = []; //remove all items from array
                for (i = 0; i < acquirer_response.data.records.length; i++) {
                  this.acquirers.push({
                    id: acquirer_response.data.records[i].id,
                    name: acquirer_response.data.records[i].acquirerName,
                  });
                  //console.log("acquirers", this.acquirers)
                }
              }
            }
          })
        );
    }, //end of requests_handler 2 method

    //not in use
    async updateAid() {
      //this.dialog_update = false
      // console.log("update form aid id", this.aidId);
      // console.log("update form aid..", this.aid_data);
      this.checkTokenExpiry();

      //DO NOT DELETE
      /* this.exist = false;
          //check if AID exist
          if(this.existing_aid != this.aid_data.f_aid){
            try {
                let result_aid = await axios.get(window.baseurl+"aids/"+ this.aid_data.f_aid + "/"+ this.orgId , 
                  {"headers": {'Authorization': 'Bearer ' + this.accessToken} }
                )
                console.log("RESPONSE", result_aid)
                if (result_aid.status == 200) {
                  //alert("device exist");
                  //this.show_toast(true, "warning", "Aid exist"); 
                  this.$root.vtoast.showError({message: this.aid_data.f_aid + " Already exist"})
                  console.log("EXIST", "AID exist")
                  this.exist = true;
                  //console.log("EXIST value 1", this.exist)
                  
                }   
            }
            catch (error) {
                console.log("EXIST", "aid does not exist")
                console.log(error.response.data);
                if(error.response.data.status == 500){
                  this.exist = false;
                  console.log("EXIST value 2", this.exist)
                  
                }
                //this.$root.vtoast.showError({message: error.message})
                
            }
          }
          else{ 
              console.log("EQUAL", "true")          
              this.exist = false;
          } */

      //if exist do not submit to database else submit
      if (this.exist) {
        this.$root.vtoast.showError({ message: this.$t(" ") });
        // console.log("EXIST112", this.exist);
      } else {
        try {
          let result = await axios.put(
            window.baseurl + "" + "aids/" + this.aidId,
            {
              aidName: this.aid_data.f_aidName,
              aid: this.aid_data.f_aid,
              selFlag: this.aid_data.f_selFlag,
              priority: this.aid_data.f_priority,
              onlinePin: this.aid_data.f_onlinePin,
              targetPer: this.aid_data.f_targetPer,
              maxTargetPer: this.aid_data.f_maxTargetPer,
              floorLimit: this.aid_data.f_floorLimit,
              floorLimitCheckFlg: this.aid_data.f_floorLimitCheckFlg,
              randTransSel: this.aid_data.f_randTransSel,
              velocityCheck: this.aid_data.f_velocityCheck,
              threshold: this.aid_data.f_threshold,
              tacDenial: this.aid_data.f_tacDenial,
              tacOnline: this.aid_data.f_tacOnline,
              tacDefault: this.aid_data.f_tacDefault,
              acquirerId: this.aid_data.f_acquirerId,
              dDOL: this.aid_data.f_dDOL,
              tDOL: this.aid_data.f_tDOL,
              version: this.aid_data.f_version,
              terminalType: this.aid_data.f_terminalType,
              terminalCapability: this.aid_data.f_terminalCapa,
              terminalAdditionalCapability: this.aid_data.f_addTerminalCap,
              riskManageData: this.aid_data.f_riskManageData,
              //orgId:this.aid_data.f_orgId,
              organization_id: this.orgId,
              updatedBy: this.userEmail,
              acquirersList: this.aid_data.f_acquirerList,
            },
            { headers: { Authorization: "Bearer " + this.accessToken } }
          );
          console.log("update form aid result", result);
          if (result.status == 200) {
            //this.show_toast(true, "success", "Successful");
            // this.$root.vtoast.show({message: result.data.message});
            this.$root.vtoast.show({ message: this.$t("aid_updated") });
            window.setInterval(() => {
              this.dialog = false;
              this.$emit("reload");
            }, this.waiting_time);
          }
        } catch (error) {
          //this.show_toast(true, "warning", error.message);
          if (error.response.status == 417) {
            this.$root.vtoast.showError({
              message: error.response.data.message,
            });
          } else if (error.response.status == 500) {
            this.$root.vtoast.showError({
              message: error.response.data.detail,
            });
          } else {
            this.$root.vtoast.showError({
              message: error.response.data.message,
            });
          }
        }
      }
    },

    //TO BE REMOVE
    /* async updateAid() { 

        try{
              let result = await axios.patch(window.baseurl+""+"aid/update/" +""+this.aidId, {                
                aidName:this.aid_data.f_aidName,
                aid:this.aid_data.f_aid,
                selFlag:this.aid_data.f_selFlag,
                priority:this.aid_data.f_priority,
                onlinePin:this.aid_data.f_onlinePin,
                targetPer:this.aid_data.f_targetPer,
                maxTargetPer:this.aid_data.f_maxTargetPer,
                floorLimit:this.aid_data.f_floorLimit,
                floorLimitCheckFlg:this.aid_data.f_floorLimitCheckFlg,                
                randTransSel:this.aid_data.f_randTransSel,
                velocityCheck:this.aid_data.f_velocityCheck,
                threshold:this.aid_data.f_threshold,
                tacDenial:this.aid_data.f_tacDenial,
                tacOnline:this.aid_data.f_tacOnline,
                tacDefault:this.aid_data.f_tacDefault,
                acquirerId:this.aid_data.f_acquirerId,
                dDOL:this.aid_data.f_dDOL,
                tDOL:this.aid_data.f_tDOL,
                version:this.aid_data.f_version,
                terminalType:this.aid_data.f_terminalType,
                terminalCapability:this.aid_data.f_terminalCapa,
                terminalAdditionalCapability:this.aid_data.f_addTerminalCap,
                riskManageData:this.aid_data.f_riskManageData,
                //orgId:this.aid_data.f_orgId,
                orgId:this.orgId,  
                acquirerList:this.aid_data.f_acquirerList,    
                
              },
              {"headers": {'Authorization': 'Bearer ' + this.$cookies.get('accessToken')} }
              );
              console.log("update form aid result", result)
              if (result.status == 200) {
                  //alert("successfull updated");                  
                  //this.show_toast(true, "success", "Successful");
                  this.$root.vtoast.show({message: result.data.message})
                  window.setInterval(() => {
                    this.dialog = false
                      this.$router.go();
                  }, this.waiting_time)
                  //this.$router.go();
              }
            }
            catch (error){            
              //this.show_toast(true, "warning", error.message);
              this.$root.vtoast.showError({message: error.response.data.message})
            }

      }, */

    async deleteAid() {
      this.dialog_delete = false;
      this.checkTokenExpiry();
      try {
        let result = await axios.delete(
          window.baseurl + "" + "aids/" + this.aidId,
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        if (result.status == 204) {
          //alert("successfull deleted");
          //this.show_toast(true, "success", "Successful");
          // this.$root.vtoast.show({ message: result.data.message });
          this.$root.vtoast.show({ message: this.$t("aid_deleted") });
          window.setInterval(() => {
            this.$emit("reload");
          }, this.waiting_time);
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
      }
    },

    //CHECK IF AID IN FORM EXSIT
    async checkAid(aid) {
      // console.log("aid", aid);
      this.checkTokenExpiry();

      try {
        let result_aid = await axios.get(
          window.baseurl + "aids/" + aid + "/" + this.orgId,
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        // console.log("RESPONSE", result_aid);
        if (result_aid.status == 200) {
          //alert("device exist");
          //this.show_toast(true, "warning", "Aid exist");
          this.$root.vtoast.showError({
            message: aid + this.$t("already_exist"),
          });
          // console.log("EXIST", "AID exist");
          this.exist = true;
          // console.log("EXIST value 1", this.exist);
        }
      } catch (err) {
        // console.log("EXIST", "aid does not exist");
        // console.log(err.response.data);
        if (err.response.data.status == 500) {
          this.exist = false;
          // console.log("EXIST value 2", this.exist);
        }
      }
    },

    async fetchData() {
      let result;
      let page2 = this.page - 1;
      this.loading = true;
      try {
        if (
          this.global_permissions.includes("ROLE_STAFF_ADMIN") ||
          this.global_permissions.includes("ROLE_STAFF_USER")
        ) {
          result = await axios.get(window.baseurl + "aids", {
            params: { page: page2 },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("aid_object", result);
          this.aids = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        } else if (
          this.global_permissions.includes("ROLE_MOD_CARD")          
        ) {
          result = await axios.get(window.baseurl + "aids/org/" + this.orgId, {
            params: { page: page2 },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("aid_object", result);
          this.aids = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
        this.loading = false;
      }
    },

    async searchAid() {
      let result;
      let page2 = this.page - 1; //pagination starts from 1 in vue , in spring boot pgae start from zero

      this.checkTokenExpiry();
      try {
        if (
          this.global_permissions.includes("ROLE_STAFF_ADMIN") ||
          this.global_permissions.includes("ROLE_STAFF_USER")
        ) {
          result = await axios.get(window.baseurl + "aids/search", {
            params: { page: page2, search: this.query },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("search_aid_object", result);
          this.aids = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        } else if (
          this.global_permissions.includes("ROLE_MOD_CARD")          
        ) {
          result = await axios.get(
            window.baseurl + "aids/org/search/" + this.orgId,
            {
              params: { page: page2, search: this.query },
              headers: { Authorization: "Bearer " + this.accessToken },
            }
          );

          // console.log("search_aid_object", result);
          this.aids = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
        this.loading = false;
      }
    },

    //Validations
    required(v) {
      return !!v || "Field is required";
    },

    min(v) {
      return v.length >= 8 || "Min 8 characters";
    },

    validateName(value) {
      const regex = /^[A-Za-z0-9_. ]+$/;
      return (
        regex.test(value) ||
        "Name can only be numbers, characters, space, underscore and ."
      );
    },
    validateAID(value) {
      const regex = /^[A-Za-z0-9 ]+$/;
      return (
        regex.test(value) || "Name can only be numbers, characters and space."
      );
    },
    validateLimit1(value) {
      if (value >= 0 && value <= 1) {
        return true;
      } else {
        return "Minimum value is 0 and maximum value is 1.";
      }
    },
    validateLimit2(value) {
      if (value >= 0 && value <= 100) {
        return true;
      } else {
        return "Minimum value is 0 and maximum value is 100.";
      }
    },
    validateLimit3(value) {
      if (value >= 0 && value <= 1000000) {
        return true;
      } else {
        return "Minimum value is 0 and maximum value is 1000000.";
      }
    },
    validateText(value) {
      const regex = /^[0-9]{2}$/;
      return regex.test(value) || "Should be 2 characters long and numbers.";
    },
    validateText2(value) {
      const regex = /^[A-Za-z0-9]{6}$/;
      return (
        regex.test(value) ||
        "Should be 6 characters long with letters and numbers."
      );
    },
    validateText3(value) {
      const regex = /^[A-Za-z0-9 ]{10}$/;
      return (
        regex.test(value) ||
        "Should be 10 characters long with letters and numbers."
      );
    },
    validateNN(value) {
      return value !== null || "dDol must not be null.";
    },
  },
  //get list of acquirers
  async mounted() {
    this.checkTokenExpiry();

    //get user list
    this.fetchData();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
